import React, { useMemo } from 'react';
import { Input as NextUIInput } from "@heroui/react";
import { twMerge } from 'tailwind-merge';


export const Input = (
  {
    classNames = {},
    placeholder = " ",
    labelPlacement = "outside",
    variant = "bordered",
    type = "text",
    isInvalid = false,
    errorMessage = "",
    ...props
  }) => {
  const defaultKlassName = {
    inputWrapper: isInvalid ? 'border-[#f31260] !bg-[#fcf2f2]' : 'border-[#bac2c6]',
    label: '!text-[#293538]',
    errorMessage: "text-[#f31260] text-sm mt-1"
  }

  const mergedKlassName = useMemo(() => {
    let merged = Object.assign({}, defaultKlassName);
    Object.keys(classNames).forEach((key) => {
      merged[key] = twMerge(merged[key], classNames[key]);
    });
    return merged;
  }, [classNames]);

  return (
    <NextUIInput
      classNames={mergedKlassName}
      placeholder={placeholder}
      labelPlacement={labelPlacement}
      variant={variant}
      type={type}
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      {...props}
    />
  )
}